import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../graph-search.component.scss']
})
export class HeaderGraphComponent {
  theme: string = 'light';
  colors: any = {
    light: {
      header_bg: '#ffffff',
      logo_src: 'assets/images/immersion_assets/Logo_Immersion1.png'
    }
  };
}